export const PanelLine = ({
    panelLinePosition,
    panelHoverTime
}) => {
    return (
        <div
            style={{
                position: "absolute",
                pointerEvents: "none",
                top: `${panelLinePosition}px`,
                zIndex: "99999",
                left: "-8",
                // width: "270px",
                width: "100%",
                height: "2px",
                backgroundColor: "red",
                pointerEvents: "none"
            }}
        >
            <span
                style={{
                    position: "absolute",
                    zIndex: "99999999",
                    top: "-22px",
                    left: "0px",
                    // backgroundColor: "white",
                    padding: "2px 5px",
                    fontSize: "12px",
                }}
            >
                {panelHoverTime} min
            </span>
        </div>
    )
}